class OffCanvasMenu extends HTMLElement {
  constructor() {
    super(), this.classNames = {
      menuParent: "offcanvas-canvas",
      menuLeft: "offcanvas--left",
      menuPush: "offcanvas--push",
      menuFilter: "offcanvas--filter",
      isOpen: "is-offcanvas-open",
      isPush: "is-offcanvas-push",
      isFilter: "is-offcanvas-filter",
      isPushLeft: "is-offcanvas-push-left",
      smoothScroll: "scroll-behavior-smooth"
    };
    const menuParentEl = document.querySelector(`.${this.classNames.menuParent}`);
    menuParentEl && this.parentElement !== menuParentEl && menuParentEl.appendChild(this),
    this.hidden = !0,
    this.addDimmer(),
    this.initControls(),
    this.smoothScroll = document.documentElement.classList.contains(this.classNames.smoothScroll)
  }

  initControls() {
    this.addEventListener("keyup", (evt => "Escape" === evt.code && this.close())),
    this.closeButtons = this.querySelectorAll('button[name="close"]'),
    this.closeButtons.forEach((b => b.addEventListener("click", this.close.bind(this)))),
    this.toggleButtons = document.querySelectorAll(`a[href="#${this.id}"], [data-menu-toggle="${this.id}"]`),
    this.toggleButtons.forEach((t => {
      t.addEventListener("click", (e => {
        e.preventDefault(),
        this.toggle(e)
      }))
    }))
  }

  toggleSmoothScroll() {
    this.smoothScroll && document.documentElement.classList.toggle(this.classNames.smoothScroll)
  }

  open(e) {
    const openClasses = [this.classNames.isOpen];
    this.hidden && (
      this.toggleSmoothScroll(),
      this.classList.contains(this.classNames.menuPush) && (
        openClasses.push(this.classNames.isPush),
        this.classList.contains(this.classNames.menuFilter) && openClasses.push(this.classNames.isFilter),
        this.classList.contains(this.classNames.menuLeft) && openClasses.push(this.classNames.isPushLeft)
      ),
      this.addEventListener("transitionend", (() => {
        this.focus(), trapFocus(this)
      }), { once: !0 }),
      this.dimmer.hidden = !1,
      this.hidden = !1,
      window.requestAnimationFrame((() => {
        this.classList.add("is-active"),
        document.body.classList.add(...openClasses)
      })),
      "NotifyMePopup" === e.target.dataset.menuToggle && this.replaceNotifyData(e.target)
    )
  }

  close() {
    this.hidden || (
      this.toggleSmoothScroll(),
      this.toggleSmoothScroll(),
      document.body.classList.remove(this.classNames.isOpen, this.classNames.isPush, this.classNames.isPushLeft, this.classNames.isFilter),
      this.addEventListener("transitionend", (() => {
        this.hidden = !0,
        this.dimmer.hidden = !0,
        removeTrapFocus(this.activeElement)
      }), { once: !0 }),
      this.classList.remove("is-active")
    )
  }

  toggle(e) {
    this.hidden ? (this.closeAllMenus(), this.open(e)) : this.close()
  }

  addDimmer() {
    this.dimmer = document.querySelector(".offcanvas-dimmer"),
    this.dimmer || (
      this.dimmer = document.createElement("div"),
      this.dimmer.classList.add("offcanvas-dimmer"),
      document.body.appendChild(this.dimmer),
      this.dimmer.addEventListener("click", this.closeAllMenus)
    )
  }

  closeAllMenus() {
    document.querySelectorAll("offcanvas-menu").forEach((menu => { menu.close() }))
  }

  replaceNotifyData(target) {
    console.log(target.dataset);
    const notifyPopUp = document.getElementById("NotifyMePopup");
    notifyPopUp.querySelector('[name="contact[SKU]"]').setAttribute("value", target.dataset.variantSku),
    notifyPopUp.querySelector('[name="contact[barcode]"]').setAttribute("value", target.dataset.variantBarcode),
    notifyPopUp.querySelector('[name="contact[Variant]"]').setAttribute("value", target.dataset.variantId),
    notifyPopUp.querySelector('[name="contact[productSize]"]').setAttribute("value", target.dataset.variantSize),
    notifyPopUp.querySelector('[name="contact[soleType]"]').setAttribute("value", target.dataset.variantSoleType),
    target.dataset.productId && (
      notifyPopUp.querySelector('[name="contact[Product]"]').setAttribute("value", target.dataset.productId),
      notifyPopUp.querySelector('[name="contact[productName]"]').setAttribute("value", target.dataset.productName),
      notifyPopUp.querySelector('[name="contact[Product URL]"]').setAttribute("value", target.dataset.productUrl)
    ),
    target.dataset.gender ? 
      notifyPopUp.querySelector(".product-size span").textContent = target.dataset.variantSize + " - " + target.dataset.gender :
      notifyPopUp.querySelector(".product-size span").textContent = target.dataset.variantSize,
    notifyPopUp.querySelector(".product-price").textContent = target.dataset.variantPrice,
    notifyPopUp.querySelector(".notify-me-form .form").classList.remove("hidden"),
    notifyPopUp.querySelector(".success-message").classList.add("hidden"),
    notifyPopUp.querySelector(".already-error-message").classList.add("hidden"),
    notifyPopUp.querySelector(".error-message").classList.add("hidden");

    const soleTypeContainer = notifyPopUp.querySelector(".sole_type"),
          soleTypeSpan = soleTypeContainer?.querySelector("span");
    target.dataset.variantSoleType && soleTypeSpan ? (
      soleTypeSpan.textContent = target.dataset.variantSoleType,
      soleTypeContainer.classList.remove("hidden")
    ) : soleTypeContainer && soleTypeContainer.classList.add("hidden")
  }
}

customElements.define("offcanvas-menu", OffCanvasMenu);
